import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-online-rahul-joshi',
  templateUrl: './online-rahul-joshi.component.html',
  styleUrls: ['./online-rahul-joshi.component.scss']
})
export class OnlineRahulJoshiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
